/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';
import {TooltipEl} from 'common/components/tooltip';
import {Placement} from 'common/components/tooltip/types';

import type {CreateAnnotationButton} from './index';

export function template(this: CreateAnnotationButton) {
  return (
    <div
      attrs={{role: `button`}}
      class={{'create-annotations-button-container': true, active: this.isAttributeEnabled(`active`)}}
    >
      <TooltipEl placement={Placement.Top}>Add Annotation</TooltipEl>
      <SvgIconEl attrs={{icon: `plus`}} />
    </div>
  );
}
